import { Moment } from 'moment'

import { Person } from '../../../App/store/features/person/IPerson'
import { IUpdateAppointmentData } from '../../store/thunks/updateAppointmentActivity'
import { IEvent, IEventCoordinates } from '../../types'

import { updateColumnCalculation } from './updateColumnCalculation'

export const updateAppointmentActivityMoment = (
  eventCoordinates: IEventCoordinates,
  event: IEvent,
  filteredPersons: Person[],
): IUpdateAppointmentData => {
  const {
    eventNewColumnNumber,
    eventNewY,
    eventPixelHeight,
    pixelsPerHour,
    selectedStartDate,
  } = eventCoordinates

  const { id } = event

  const { personArrayPosition, droppedDayNumber } = updateColumnCalculation(
    eventNewColumnNumber,
    filteredPersons.length,
  )
  const droppedAtMinutes: number = (eventNewY / pixelsPerHour) * 60
  const eventDuration: number = (eventPixelHeight / pixelsPerHour) * 60
  const resetStartAt: Moment = selectedStartDate.clone().set({ h: 0, m: 0 })

  // TODO look in this -1
  const updatedEventStartAt: Moment = resetStartAt
    .clone()
    .add(droppedDayNumber - 1, 'days')
    .add(droppedAtMinutes, 'minutes')

  const appointmentActivityId: number = parseInt(
    id.substring(id.indexOf('_') + 1),
    10,
  )

  return {
    id: appointmentActivityId,
    startsAt: updatedEventStartAt,
    endsAt: updatedEventStartAt.clone().add(eventDuration, 'minutes'),
    personId: filteredPersons[personArrayPosition].id,
    updateRepeatAppointments: false,
    isLocked: null,
  }
}
